import { render, staticRenderFns } from "./DistributionStu.vue?vue&type=template&id=17bd790a"
import script from "./DistributionStu.vue?vue&type=script&lang=js"
export * from "./DistributionStu.vue?vue&type=script&lang=js"
import style0 from "./DistributionStu.vue?vue&type=style&index=0&id=17bd790a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports